import React from 'react';

// Clean SVG home icon used in breadcrumbs (replaces the 🏠 emoji)
export default function HomeIcon({ size = 15, color = '#64748b', onClick, style }) {
    return (
        <span
            className="home-icon-svg"
            onClick={onClick}
            title="Home"
            style={{ display: 'inline-flex', alignItems: 'center', color, cursor: onClick ? 'pointer' : 'default', ...style }}
        >
            <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M3 10.5L12 3l9 7.5" />
                <path d="M5 9.5V20a1 1 0 0 0 1 1h4v-6h4v6h4a1 1 0 0 0 1-1V9.5" />
            </svg>
        </span>
    );
}
